import {
  AllEnumsDocument as Document,
  AllEnumsQueryResult as Result,
  AllEnumsQueryVariables as Variables,
  InvestmentCategoryName,
  InvestmentGeographyName,
  InvestmentStageName,
  FundingStageName
} from 'generated/graphql';
import _ from 'lodash';
import { apolloService } from 'modules';



export interface IGenericEnum<TOptionName extends string> {
  id: string;
  name: TOptionName;
  displayName: string;
}



export interface IExtendedEnum<TOptionName extends string> {
  id: string;
  name: TOptionName;
  displayName: string;
  parentName: string | null;
  ranking: number;
}



export interface IAllEnums {
  investmentCategories: IGenericEnum<InvestmentCategoryName>[];
  investmentGeographies: IGenericEnum<InvestmentGeographyName>[];
  investmentStages: IGenericEnum<InvestmentStageName>[];
  investmentAreas: IGenericEnum<string>[];
  usStates: IGenericEnum<string>[];
  fundingStages: IGenericEnum<FundingStageName>[];
}



export async function runQuery(client: apolloService.IApolloClient): Promise<IAllEnums> {
  const queryResult = await client.query<Result['data'], Variables>({
    query: Document,
    variables: {}
  });

  return {
    investmentCategories: __gqlObjects2Clients<InvestmentCategoryName>(queryResult.data?.investmentCategories ?? []),
    investmentGeographies: __gqlObjects2Clients<InvestmentGeographyName>(queryResult.data?.investmentGeographies ?? []),
    investmentStages: __gqlObjects2Clients<InvestmentStageName>(queryResult.data?.investmentStages ?? []),
    investmentAreas: __gqlLiteObjects2Clients(queryResult.data?.investmentAreas ?? []),
    usStates: __gqlLiteObjects2Clients(queryResult.data?.usStates ?? []),
    fundingStages: __gqlObjects2Clients<FundingStageName>(queryResult.data?.fundingStages ?? [])
  };
}



interface IGqlEnumObject<TEnumName extends string> {
  id: string;
  name: TEnumName;
  displayName: string;
}

function __gqlObject2Client<TEnumName extends string>(gqlObject: IGqlEnumObject<TEnumName>): IGenericEnum<TEnumName> {
  return {
    id: gqlObject.id,
    name: gqlObject.name,
    displayName: gqlObject.displayName
  };
}



function __gqlObjects2Clients<TEnumName extends string>(gqlObjects: IGqlEnumObject<TEnumName>[]) {
  return _.map(gqlObjects, gqlObject => __gqlObject2Client(gqlObject));
}

interface IGqlEnumLiteObject {
  id: string;
  displayName: string;
}

function __gqlLiteObject2Client(gqlObject: IGqlEnumLiteObject): IGenericEnum<string> {
  return {
    id: gqlObject.id,
    name: gqlObject.displayName,
    displayName: gqlObject.displayName
  };
}

function __gqlLiteObjects2Clients(gqlObjects: IGqlEnumLiteObject[]) {
  return _.map(gqlObjects, gqlObject => __gqlLiteObject2Client(gqlObject));
}
